import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitorSmartphone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8M10 19v-3.96 3.15M7 19h5" }), /* @__PURE__ */ _jsx("rect", {
		width: 6,
		height: 10,
		x: 16,
		y: 12,
		rx: 2
	})]
});
const Memo = memo(SvgMonitorSmartphone);
export default Memo;
